export const featureItems = [
  {
    id: "20",
    img: "PC6",
    name: "Der kleine Allrounder",
    category: "PC",
    price: 740.49,
  },

  {
    id: "30",
    img: "Mouse5",
    name: "Gaming Maus",
    category: "MÄUSE",
    price: 49.99,
  },

  {
    id: "22",
    img: "Tast4",
    name: "Ergonomische Tastatur",
    category: "TASTATUREN",
    price: 29.99,
  },

  {
    id: "27",
    img: "Lap6",
    name: "16 Zoll - Notebook",
    category: "LAPTOPS",
    price: 679.89,
  }
]


  export const popularProducts = [
    {
      id: "1",
      img: "Lap1",
      name: "Office Notebook i5-1340P",
      desc: "Das Office Notebook V5 ist das absolute Leichtgewicht im Portfolio bei MIFCOM. Diese Aussage trifft sowohl auf die Leistungsfähigkeit, als auch auf die Mobilität zu. Ausgestattet mit einem Intel Core Prozessor der Raptor Lake Generation behält sich das V5 vor, komplett ohne eigene Grafikkarte auszukommen.",
      detailOne: "Intel Core i5-1340P, 4 + 8 Cores",
      detailTwo: "AMD/Intel Integrated, 1TB WD Black SN770",
      detailThree: "2 Jahre Garantie",
      category: "LAPTOPS",
      price: 899.69
    },

    {
      id: "2",
      img: "Lap2",
      name: "Notebook V15 G2 ALB - FHD 15,6 Zoll",
      desc: "Das 39,6cm V15 ist wie ein Bürogehilfe, der Ihre täglichen Aufgaben effizient erledigt. Dadurch bleibt Ihr Unternehmen produktiv und Ihre Daten sicher. Das dünne, schlanke Design und die schmalen Displayränder sorgen für ein professionelles Erscheinungsbild, egal ob im Büro oder unterwegs.",
      category: "LAPTOPS",
      detailOne: "Intel Core i3-1340P",
      detailTwo: "AMD Ryzen 5 5500U, 512GB WD Black SN770",
      detailThree: "2 Jahre Garantie",
      price: 699.99
    },

    {
      id: "3",
      img: "PC1",
      name: "PC - SL Sprint G8839",
      desc: "Der Sprint G8839 ist ein starker Allround-PC mit erstklassigem Preis-/Leistungsverhältnis und überzeugender Performance für Office, Multimedia und eSports-Gaming.", 
      category: "PC",
      detailOne: "AMD RYZEN 3 3200G, 4X 3600 MHZ",
      detailTwo: "RADEON VEGA 8 ONCHIP",
      detailThree: "2 Jahre Garantie",
      price: 387.89
    },

    {
      id: "4",
      img: "Mon1",
      name: "27 Zoll PC Monitor",
      desc: "240 Hz entfesseln das Potenzial von High-End-Grafikkarten und sorgt für nie dagewesene Flüssigkeit im Bildaufbau des Bildschirms. Da alle Details scharf in deinen Fokus gebracht und alle Bewegungen kristallklar präsentiert werden, wirst du fühlen, dass deine Reaktionen eine Einheit mit der Action bilden und das Spiel emporheben.",
      category: "MONITORE",
      detailOne: "240Hz Bildwiederholfrequenz",
      detailTwo: "Full HD Auflösung",
      detailThree: "2 Jahre Garantie",
      price: 245.79
    },

    {
      id: "5",
      img: "PC2",
      name: "Rechenstarker Allrounder",
      desc: "Mit dem PC holen Sie sich ein sehr rechenstarkes Allround-System, mit dem Sie für Office- und Multimedia-Anwendungen bestens aufgestellt sind. Der PC basiert auf einem Intel® Core™ i5-12400 Prozessor der 12. Core™ Generation.",
      category: "PC",
      detailOne: "WINDOWS 11 HOME, 64 BIT, INKL. USB-STICK",
      detailTwo: "INTEL CORE I5-12400, 6X 2500 MHZ",
      detailThree: "2 Jahre Garantie",
      price: 499.99,
    },

    {
      id: "6",
      img: "Lap3",
      name: "15,6 Zoll - Notebook für Business",
      desc: "Die Ausstattungsmerkmale umfassen eine HD Webcam, ein Multi-Touchpad und eine LED-beleuchtete Tastatur. Der integrierte Fingerprint-Sensor erhöht die Sicherheit und ermöglicht eine bequeme Anmeldung über Windows Hello.",
      category: "LAPTOPS",
      detailOne: "SSD Speicherkapazität 256GB",
      detailTwo: "Windows 11 Pro",
      detailThree: "2 Jahre Garantie",
      price: 428.59,
    },

    {
      id: "7",
      img: "Mon2",
      name: "28 Zoll PC Monitor",
      desc: "Der 28 Zoll Monitor, ist besonders gut für den Office- und Multimedia-Einsatz eignet. Das IPS-Display garantiert eine enorm hohe Blickwinkelstabilität bis zu 178° und stellt strahlende Farben gleichmäßig auf dem ganzen Bildschirm dar.",
      category: "MONITORE",
      detailOne: "1× DisplayPort 1.2, 2× HDMI 2.0",
      detailTwo: "OnScreen Display, Low Blue Light",
      detailThree: "2 Jahre Garantie",
      price: 209.87,
    },

    {
      id: "8",
      img:  "PC3",
      name: "Intel Gaming PC",
      desc: "Dieser Gaming PC ist maßgeschneidert für intensives Full HD-Gaming! Das System basiert auf einem Intel® Core™ i5-14400F Zehnkern-Prozessor und einer GeForce® RTX 3050 Grafikkarte.",
      category: "PC",
      detailOne: "GAINWARD GEFORCE RTX 3050, GAINWARD GEFORCE RTX 3050 PEGASUS",
      detailTwo: "INTEL CORE I5-14400F, 10 KERNE (6+4), 6X 2500 MHZ",
      detailThree: "2 Jahre Garantie",
      price: 699.99,
    },

    {
      id: "9",
      img: "Tast1",
      name: "RGB Tastatur White",
      desc: "Die mechanische Gaming-Tastatur mit ultrakompakten 65%-Formfaktor die sowohl kabellos per 2,4 GHz Funk als auch kabelgebunden per USB genutzt werden kann.",
      category: "TASTATUREN",
      detailOne: "2,4 GHz Funk, USB-C",
      detailTwo: "ABS Doubleshot-Tastenkappen",
      detailThree: "2 Jahre Garantie",
      price: 139.99,
    },

    {
      id: "10",
      img: "Mouse1",
      name: "Wireless Maus",
      desc: "Die Wireless Maus überzeugt mit ihrem eleganten, leichten Design und erstklassiger Performance. Beim Anschluss bietet sie dank ultraschneller Slipstream-Wireless-Technologie und Bluetooth® optimale Flexibilität.",
      category: "MÄUSE",
      detailOne: "Auflösung (dpi) 1000 DPI",
      detailTwo: "Rechts- & Linkshänder",
      detailThree: "2 Jahre Garantie",
      price: 15.79,
    },

    {
      id: "11",
      img: "PC4",
      name: "Gaming PC",
      desc: "Dieser Gaming PC überzeugt mit kompaktem Design und starker Leistung für flüssiges Gaming in Full HD. Dank effizienter Kühlung bleibt das System auch unter Last angenehm leise.",
      category: "PC",
      detailOne: "ASUS GEFORCE RTX 3060, ASUS DUAL-RTX3060-O12G-V2, 12 GB GDDR6",
      detailTwo: "INTEL CORE I5-14500, 14 KERNE (6+8), 6X 2600 MHZ",
      detailThree: "2 Jahre Garantie",
      price: 859.59,
    },

    {
      id: "12",
      img: "Tast2",
      name: "Wireless Keyboard",
      desc: "Die hochklassige kabellose Tastatur, die speziell für Kreative und Programmierer entwickelt wurde. Der Verbindungsaufbau funktioniert über den im Lieferumfang enthaltenen Unifying USB-Empfänger oder die Bluetooth Low Energy Technologie.",
      category: "TASTATUREN",
      detailOne: "2,4 GHz Funk (mit beiliegenden Unifying USB-Empfänger) Bluetooth® LE",
      detailTwo: "Deutsches QWERTZ-Layout, Perfect Stroke Tasten",
      detailThree: "2 Jahre Garantie",
      price: 69.59,
    },

    {
      id: "13",
      img: "Mouse3",
      name: "Vertikal Maus",
      desc: "Die Vertikal-Maus ist die perfekte Wahl für alle, die viel mit der Maus arbeiten und die Stabilität einer kabelgebundenen Maus nutzen möchten! Das ergonomische Vertikal-Design beugt hohen Belastungen beim intensiven Arbeiten am PC gezielt vor.",
      category: "MÄUSE",
      detailOne: "5 Tasten inkl. Scrollrad dpi-Wahlschalter",
      detailTwo: "optischer Sensor 125 Hz Polling Rate",
      detailThree: "2 Jahre Garantie",
      price: 19.99,
    },

    {
      id: "14",
      img: "Lap4",
      name: "FHD 15,6 Zoll Notebook",
      desc: " Ausgestattet mit einem Full HD IPS-Display, einem Intel® N200 Quadcore-Prozessor, 16 GB RAM und einer 1000 GB PCIe SSD bietet es hervorragende Leistung für gängige Aufgaben wie Surfen, Videostreaming, Office-Anwendungen und Bildbearbeitung.",
      category: "LAPTOPS",
      detailOne: "INTEL N200, 4X 3700 MHZ INTEL BURST FREQUENZ",
      detailTwo: "INTEL U/HD-GRAFIK ONCHIP",
      detailThree: "2 Jahre Garantie",
      price: 575.79,
    },

    {
      id: "15",
      img: "Mon3",
      name: "24 Zoll PC Monitor",
      desc: "Der Full HD Monitor hat 24 Zoll IPS-Display! Er ist ideal für den Office- & Business-Bereich geeignet und überzeugt dank AH IPS-Panel auch bei großen horizontalen sowie vertikalen Betrachtungswinkeln bis zu 178° mit kontrastreicher Darstellung.",
      category: "MONITORE",
      detailOne: "1920 × 1080 Pixel (Ultra Wide Full HD)",
      detailTwo: "60 Hz Bildwiederholungsrate",
      detailThree: "2 Jahre Garantie",
      price: 149.99,
    },

    {
      id: "16",
      img: "PC5",
      name: "Gaming PC",
      desc: "Hol' Dir die bewährte Hardware mit bester Preis-Leistung: dieses System setzt auf einen schnellen AMD R5-Prozessor auf einem B550-Motherboard. Auch die restliche Ausstattung ist hochwertig sowie passend dimensioniert. 16GB DDR4-3200 RAM bieten genug Reserven selbst für aufwendiges Multitasking",
      category: "PC",
      detailOne: "AMD Ryzen 5 5600X, 6x 3.7GHz, RTX 4060 Ti 8GB, ASUS Dual SI",
      detailTwo: "1TB Western Digital Blue SN580, 16GB DDR4-3200, Corsair RGB",
      detailThree: "3 Jahre Garantie",
      price: 1109.89,
    },

    {
      id: "17",
      img: "Mouse2",
      name: "Standard Maus",
      desc: "Sie können mit dieser Maus für Links- und Rechtshänder den ganzen Tag lang komfortabel arbeiten. Diese Plug&Play-Maus ist einfach einzurichten. Schließen Sie sie einfach an den USB-Anschluss an und schon können Sie weiterarbeiten.",
      category: "MÄUSE",
      detailOne: "Auflösung (dpi) 800",
      detailTwo: "Kabelgebunden",
      detailThree: "2 Jahre Garantie",
      price: 11.99,
    },

    {
      id: "18",
      img: "Tast3",
      name: "Gaming Tastatur",
      desc: "Die mechanische Gaming-Tastatur mit ultrakompakten 65%-Formfaktor die sowohl kabellos per 2,4 GHz Funk als auch kabelgebunden per USB genutzt werden kann. Mit 68 Tasten, Cherry-MX-RGB-Red-Schaltern und interaktivem Touch-Panel.",
      category: "TASTATUREN",
      detailOne: "mechanische Cherry MX RGB-Schalter mit 45g Betätigungskraft / 4mm",
      detailTwo: "Individuelle Tastenbeleuchtung, Interaktives Touch-Panel",
      detailThree: "2 Jahre Garantie",
      price: 169.98,
    },

    {
      id: "19",
      img: "Mouse4",
      name: "Business Maus",
      desc: "USB-Office-Maus, beidhändig verwendbar und einem optischen Sensor mit einer Auflösung von 800 DPI.", 
      category: "MÄUSE",
      detailOne: "Auflösung (dpi) 800",
      detailTwo: "Kabelgebunden",
      detailThree: "2 Jahre Garantie",
      price: 9.99,
    },

    {
      id: "20",
      img: "PC6",
      name: "Der kleine Allrounder",
      desc: "Der Mini-PC liefert Ihnen die starke Leistung eines vollwertigen Desktop-PCs. Ob verzögerungsfreies Surfen im Netz, Arbeiten mit Office-Software, Streamen von UHD 4K-Inhalten oder Spielen in Full HD – dieser ultrakompakte Mini-PC hat die Power für ganz große Aufgaben.",
      category: "PC",
      detailOne: "AMD Ryzen 9 5900HX, 8× 3300 MHz",
      detailTwo: "1 TB SSD, M.2 PCIe, Kingston",
      detailThree: "2 Jahre Garantie",
      price: 740.49,
    },

    {
      id: "21",
      img: "PC7",
      name: "Mini PC Kompakt",
      desc: "Der kompakte Mini-PC ist für Office-Anwendungen und 4K-Home-Entertainment geeignet. Der kleine, leichte PC ist mit einer Passivkühlung sowie Solid State-Komponenten ausgestattet und arbeitet jederzeit absolut lautlos.",
      category: "PC",
      detailOne: "Intel Quad-Core N5100, 4× 2800 MHz Intel Burst Frequenz",
      detailTwo: "Windows 11 Pro, 64Bit, inkl. Installation",
      detailThree: "2 Jahre Garantie",
      price: 339.49,
    },

    {
      id: "22",
      img: "Tast4",
      name: "Ergonomische Tastatur",
      desc: "Ergonomische Kabeltastatur mit geschwungenem Tastenfeld und Handauflage: Für natürlichere Körperhaltung und stressreduziertes Arbeiten am Computer. Weich gepolsterte Handballenauflage mit Memory-Schaum und hochwertigem PU-Leder: Unterstützt ermüdungsfreies Tippen und verhindert Druckstellen",
      category: "TASTATUREN",
      detailOne: "Tastentechnologie: Standard / Rubber Dome",
      detailTwo: "Verbindung: kabelgebunden",
      detailThree: "2 Jahre Garantie",
      price: 29.99,
    },

    {
      id: "23",
      img: "Lap5",
      name: "Convertible Notebook für Business",
      desc: "In diesem portabelsten Laptop steckt jetzt noch mehr Leistung.", 
      category: "LAPTOPS",
      detailOne: "SSD Speicherkapazität 64GB",
      detailTwo: "Prozessortyp Qualcomm Snapdragon 7c-7180c",
      detailThree: "2 Jahre Garantie",
      price: 428.59,
    },

    {
      id: "24",
    img: "Lap8",
    name: "Gaming Notebook mit 2TB SSD",
    desc: "Mit beeindruckender Gaming-Performance und exzellenter Ausstattung kann das Gaming Notebook voll überzeugen. Ein Intel® Core™ i5-13500H 12-Kern-Prozessor und eine GeForce® RTX 4050 Grafikkarte machen Gaming-Sessions zu einem eindrucksvollen Erlebnis.",
    category: "LAPTOPS",
    detailOne: "NVIDIA GEFORCE RTX 4050, 6 GB GDDR6",
    detailTwo: "INTEL CORE I5-13500H, 12 KERNE (4+8), 4× 2600 MHZ",
    detailThree: "2 Jahre Garantie",
    price: 998.79,
    },

    {
      id: "25",
      img: "Mon4",
      name: "27 Zoll PC / Gaming Monitor",
      desc: "Dieser 27 Zoll Monitor bietet eine beeindruckende Bildqualität und eine Vielzahl von Funktionen, von der Sie bei der Arbeit, beim Gaming oder Multimedia-Anwendungen profitieren.",
      category: "MONITORE",
      detailOne: "WQHD 2560 × 1440 Pixel",
      detailTwo: "Pixelabstand 0,233 mm, Helligkeit max. 250 cd/m³",
      detailThree: "2 Jahre Garantie",
      price: 169.99,
    },

    {
      id: "26",
      img: "Mon5",
      name: "34 Zoll Gaming Monitor",
      desc: "Dieser hochmoderne Monitor bieten kristallklare Vierfach-HD-UltraWide-Bilder mit 3.440 x 1.440 Pixeln. Dank der Hochleistungsanzeigen mit einer hohen Pixeldichte und 178°/178° breiten Betrachtungswinkeln erwecken diese neuen Monitore Ihre Bilder und Grafiken zum Leben.",
      category: "MONITORE",
      detailOne: "Auflösung/Format:	3440x1440, 21:9",
      detailTwo: "White-LED, flicker-free, Blaulichtfilter",
      detailThree: "2 Jahre Garantie",
      price: 349.79,
    },

  {
    id: "27",
    img: "Lap6",
    name: "16 Zoll - Notebook",
    desc: "Das 16 Zoll IPS-Display stellt Fotos und Filme gestochen scharf in Full HD 1080p dar. Kräftige Farben, ausgezeichnete Kontrastwerte und die hohe Blickwinkelstabilität der IPS-Technologie sorgen für eine erstklassige Darstellungsqualität.",
    category: "LAPTOPS",
    detailOne: "SSD Speicherkapazität 1TB",
    detailTwo: "Prozessortyp Intel Core i9-13950HX",
    detailThree: "2 Jahre Garantie",
    price: 679.89,
  },

  {
    id: "28",
    img: "Lap7",
    name: "Notebook mit 1TB SSD",
    desc: "Mit beeindruckender Performance und exzellenter Ausstattung kann das Notebook voll überzeugen.",
    category: "LAPTOPS",
    detailOne: "Intel Core i7-1005G1",
    detailTwo: "Intel UHD Graphics",
    detailThree: "2 Jahre Garantie",
    price: 598.99,
  },

  {
    id: "29",
    img: "Tast5",
    name: "Mini Tastatur",
    desc: "Tragbare Mini-Tastatur mit 60 % – die kleine Snpurdiri k60-Gaming-Tastatur hat alle Funktionen einer Standardtastatur und spart gleichzeitig mehr Platz auf Ihrem Schreibtisch. Das abnehmbare Typ-C-Kabel macht sie auf Reisen tragbarer.",
    category: "TASTATUREN",
    detailOne: "Breite Kompatibilität – Plug-and-Play",
    detailTwo: "Verbindung: kabelgebunden oder auch kabellos verwendbar",
    detailThree: "2 Jahre Garantie",
    price: 59.49,
  },

  {
    id: "30",
    img: "Mouse5",
    name: "Gaming Maus",
    desc: "USB-Gaming-Maus, mit einem optischen Sensor bei einer Auflösung von 800 DPI.", 
    category: "MÄUSE",
    detailOne: "Mit Programierbaren Tasten",
    detailTwo: "Kabelgebunden",
    detailThree: "2 Jahre Garantie",
    price: 49.99,
  }
]